import React from 'react';
import BaseIcon from './BaseIcon';

const AddRecipientsIcon = (props) => {
  const pathData = [
    'M10.5 5.63111C8.96588 5.63111 7.72222 4.37054 7.72222 2.81556C7.72222 1.26057 8.96588 0 10.5',
    '0C12.0341 0 13.2778 1.26057 13.2778 2.81556C13.2778 4.37054 12.0341 5.63111',
    '10.5 5.63111ZM15.5 10.5583C15.5 12.8908 5.5 12.8908 5.5 10.5583C5.5 8.22585 7.73858 6.335',
    '10.5 6.335C13.2614 6.335 15.5 8.22585 15.5 10.5583ZM2.5 4V2.5C2.5 2.22386 2.72386 2 3',
    '2C3.27614 2 3.5 2.22386 3.5 2.5V4H5C5.27614 4 5.5 4.22386 5.5 4.5C5.5 4.77614 5.27614 5 5',
    '5H3.5V6.5C3.5 6.77614 3.27614 7 3 7C2.72386 7 2.5 6.77614 2.5 6.5V5H1C0.723858 5 0.5 4.77614',
    '0.5 4.5C0.5 4.22386 0.723858 4 1 4H2.5Z',
  ].join(' ');

  return (
    <BaseIcon {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d={pathData} />
      </g>
    </BaseIcon>
  );
};

export default AddRecipientsIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/AddRecipientsIcon.jsx